import angular from 'angular';
import { SelecaoDeColaboradoresFormController } from './selecao-de-colaboradores.form.controller';

export class SelecaoDeColaboradoresUploadLoteFormComponent implements angular.IComponentOptions {
    static selector = 'selecaoDeColaboradoresUploadLoteFormComponent';
    static controller = SelecaoDeColaboradoresFormController;
    static template = require('!!html-loader!./selecao-de-colaboradores.form.html');
    static transclude = true;
    static bindings = {
        entity: '=',
        form: '<?',
        editable: '<',
    };
}
